import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AlertCircle } from 'lucide-react';
import ImagemPergunta from './ImagemPergunta';

const PerguntaMultiplaEscolha = ({ pergunta, indice }) => {
  const { register, formState: { errors } } = useFormContext();
  const fieldName = `respostas.${pergunta.id}`;
  const erro = errors?.respostas?.[pergunta.id];

  // "required" não valida corretamente um grupo de checkboxes com o mesmo
  // nome (valida cada input isolado, não "ao menos um marcado") — por isso
  // usa "validate" no array coletado pelo react-hook-form.
  const regraObrigatoria = pergunta.obrigatoria
    ? { validate: (value) => (Array.isArray(value) && value.length > 0) || 'Selecione ao menos uma opção' }
    : {};

  return (
    <div className="card">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        {indice}. {pergunta.texto}
        {pergunta.obrigatoria && <span className="text-red-500 ml-1">*</span>}
      </h3>

      <ImagemPergunta imagemPath={pergunta.imagem_path} />

      <div className="space-y-3">
        {pergunta.opcoes.map((opcao) => (
          <label key={opcao.slug} className="checkbox-option cursor-pointer">
            <input
              {...register(fieldName, regraObrigatoria)}
              type="checkbox"
              value={opcao.slug}
              className="h-4 w-4 text-primary-600 focus:ring-primary-500 rounded"
            />
            <span className="text-gray-700">{opcao.texto}</span>
          </label>
        ))}
      </div>

      {erro && (
        <p className="mt-3 text-sm text-red-600 flex items-center gap-1">
          <AlertCircle className="w-4 h-4" /> {erro.message}
        </p>
      )}
    </div>
  );
};

export default PerguntaMultiplaEscolha;
